import { render, staticRenderFns } from "./keluargaKatolik.vue?vue&type=template&id=9629aacc&"
import script from "./keluargaKatolik.vue?vue&type=script&lang=js&"
export * from "./keluargaKatolik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports